export let MessageBoxTypes = /*#__PURE__*/function (MessageBoxTypes) {
  MessageBoxTypes["Confirm"] = "Confirm";
  MessageBoxTypes["Error"] = "Error";
  MessageBoxTypes["Information"] = "Information";
  MessageBoxTypes["Success"] = "Success";
  MessageBoxTypes["Warning"] = "Warning";
  return MessageBoxTypes;
}({});